export const masterColors = [
    { _id: 0, name: "White" },
    { _id: 1, name: "Black" },
    { _id: 2, name: "Grey" },
    { _id: 3, name: "Beige" },
    { _id: 4, name: "Brown" },
    { _id: 5, name: "Red" },
    { _id: 6, name: "Orange" },
    { _id: 7, name: "Yellow" },
    { _id: 8, name: "Green" },
    { _id: 9, name: "Blue" },
    { _id: 10, name: "Purple" },
    { _id: 11, name: "Pink" },
    { _id: 12, name: "Gold" },
    { _id: 13, name: "Silver" }
];
